import React, { Component } from 'react';
import {Link, animateScroll} from 'react-scroll';
export default class Header extends Component {

	scrollToTop() {
		animateScroll.scrollToTop();
		// onClick={this.scrollToTop}
	}

	handleSetActive(to) {
		console.log(to)
	}

  render() {
    return (

      <nav className="navbar navbar-default navbar-fixed-top navbar_deng">
		  <div className="container">

		    <div className="navbar-header">
		      <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#mobile_menu" aria-expanded="false">
		        <span className="sr-only">Toggle navigation</span>
		        <span className="icon-bar"></span>
		        <span className="icon-bar"></span>
		        <span className="icon-bar"></span>
		      </button>
		      <a className="navbar-brand" href="/">Andri Deng</a>
		    </div>

		    <div className="collapse navbar-collapse" id="mobile_menu">
		      <ul className="nav navbar-nav navbar-right">

		        <li><Link activeClass="menu-active" to="about" spy={true} smooth={true}><i className="fa fa-user-circle-o"></i> About Me</Link></li>
		        <li><Link activeClass="menu-active" to="skills" spy={true} smooth={true} offset={-50}><i className="fa fa-star"></i> Skills</Link></li>
		        <li><Link activeClass="menu-active" to="experience" spy={true} smooth={true} offset={-50}><i className="fa fa-file-text-o"></i> Experience</Link></li>
		        <li><Link activeClass="menu-active" to="education" spy={true} smooth={true} offset={-50}><i className="fa fa-mortar-board"></i> Education</Link></li>
		        <li><Link activeClass="menu-active" to="awards" spy={true} smooth={true} offset={-50}><i className="fa fa-trophy"></i> Awards</Link></li>
		        <li><Link activeClass="menu-active" to="portfolio" spy={true} smooth={true} offset={-50}><i className="fa fa-file-code-o"></i> Portfolio</Link></li>
		        <li><Link activeClass="menu-active" to="contact" spy={true} smooth={true} offset={-50}><i className="fa fa-address-book-o"></i> Contact</Link></li>
		        
		      </ul>
		    </div> 
		  </div>
		</nav>
      
    );
  }
}



// WEBPACK FOOTER //
// ./src/guest/components/Header.js